import { useScaleApplication } from "@/domains/application/use-scale-application"
import type { WalletMenuStore } from "./wallet-menu-store"

export function useWalletMenuStore(): WalletMenuStore | undefined {
  const scaleApp = useScaleApplication()
  return scaleApp?.Wallet.Menu
}

